const PREDICTION_TIMESTAMP_KEY = "predictor_last_prediction_ts";

export function setPredictionTimestamp(): void {
    try {
        localStorage.setItem(PREDICTION_TIMESTAMP_KEY, Date.now().toString());
    } catch {
        // Silently fail if localStorage unavailable
    }
}

export function getPredictionTimestamp(): string | null {
    try {
        const value = localStorage.getItem(PREDICTION_TIMESTAMP_KEY);
        if (!value) return null;
        const parsed = parseInt(value, 10);
        if (isNaN(parsed) || parsed <= 0) return null;
        return value;
    } catch {
        return null;
    }
}
